import React from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import blog1 from '../../assets/images/blog.png';

const blogPosts = [
  {
    id: 1,
    title: 'The Ultimate Guide to Social Media Lead Generation for Real Estate Agents',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.

    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.`,
    date: 'Aug, 21 2024',
    author: 'LeadTrek Admin',
    image: blog1,
  },
  // ... Add other blog posts here
];

const BlogDetail = () => {
  const { id } = useParams();
  const post = blogPosts.find(post => post.id === parseInt(id));

  if (!post) {
    return <div>Blog post not found</div>;
  }

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/5 to-[#543DF4]/5" />
      
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -left-20 w-80 h-80 bg-[#C334F6]/10 rounded-full blur-3xl animate-float" />
        <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-[#543DF4]/10 rounded-full blur-3xl animate-float-reverse" />
      </div>

      <div className="container mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="pt-40 pb-20 px-4"
        >
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto"
          >
            <div className="relative mb-8">
              <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/20 to-[#543DF4]/20 rounded-2xl blur-2xl" />
              <img 
                src={post.image} 
                alt={post.title} 
                className="w-full h-[400px] object-cover rounded-2xl relative z-10"
              />
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="mb-8"
            >
              <h1 className="text-4xl font-normal leading-[1.2] tracking-[0.001em] text-white mb-6">
                {post.title}
              </h1>
              
              <div className="flex items-center text-white/60 mb-6">
                <span>{post.date}</span>
                <span className="mx-3">•</span>
                <span>By {post.author}</span>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="prose prose-invert max-w-none"
            >
              {post.content.split('\n\n').map((paragraph, index) => (
                <p key={index} className="text-white/80 leading-relaxed mb-6">
                  {paragraph}
                </p>
              ))}
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="mt-12 pt-8 border-t border-white/10"
            >
              <h2 className="text-2xl font-medium text-white mb-6">Share this article</h2>
              <div className="flex space-x-4">
                {['Twitter', 'Facebook', 'LinkedIn'].map((platform) => (
                  <button
                    key={platform}
                    className="px-6 py-2 rounded-full border border-white/10 text-white/60 hover:text-white hover:border-white/20 transition-all duration-300"
                  >
                    {platform}
                  </button>
                ))}
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}

export default BlogDetail;
